module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.appointment && _vm.appointment.id && _vm.table && _vm.table.data && _vm.table.activeCodeTypes) ? _c('v-card', {
    attrs: {
      "dark": _vm.dark,
      "tile": "",
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-card-title', {
    staticClass: "py-2 mr-4 pr-5"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1583155356)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4 overline pl-4"
  }, [_vm._v("\n            Coding utilities\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "disabled": _vm.table.data.length <= 1
    },
    on: {
      "click": function($event) {
        _vm.showOrder = true
      }
    }
  }, [_vm._v("\n              Set order of codes")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "flat": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("\n                  Copy codes from previous apointments")])]
      }
    }], null, false, 1455719181),
    model: {
      value: (_vm.copycodes),
      callback: function($$v) {
        _vm.copycodes = $$v
      },
      expression: "copycodes"
    }
  }, [_vm._v(" "), _c('copy-codes', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "update": _vm.clearAndLoadAppointments,
      "close": function($event) {
        _vm.copycodes = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('apply-appointment-codes', {
    attrs: {
      "disabled": _vm.table.data.length === 0 || _vm.appointment.recurring_appointment === null,
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [(_vm.withClone) ? _c('clone-appointment-codes', {
    attrs: {
      "disabled": _vm.table.data.length === 0,
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.title) ? _c('strong', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _c('strong', {
    staticClass: "overline"
  }, [_vm._v("\n        " + _vm._s(_vm.appointment.title) + ". " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd DD MMM @ hh:mma')) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showOrder) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.codeOrder && Object.keys(_vm.codeOrder).length === 0,
      "loading": _vm.requests.setorder.loading,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.setOrder
    }
  }, [_vm._v("Save order")]) : _vm._e(), _vm._v(" "), (_vm.showOrder) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showOrder = false
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.appointmentRequest.loading
    },
    on: {
      "click": _vm.clearAndLoadAppointments
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dismissible": ""
    },
    model: {
      value: (_vm.alert.visible),
      callback: function($$v) {
        _vm.$set(_vm.alert, "visible", $$v)
      },
      expression: "alert.visible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")]), _vm._v(" "), (_vm.table) ? _c('crud-table', {
    attrs: {
      "flat": "",
      "dense": "",
      "with-inline-delete": "",
      "selectable": false,
      "loading": _vm.codesUpdating || _vm.appointmentRequest.loading,
      "headers": _vm.table.headers,
      "deleteable": true,
      "items": _vm.table.data,
      "dialog-width": 600,
      "no-data-text": _vm.$t('messages.nocodes')
    },
    on: {
      "add": _vm.addCode,
      "edit": _vm.editCode,
      "delete": _vm.deleteCode
    },
    scopedSlots: _vm._u([{
      key: "before-table",
      fn: function(props) {
        return [(props.selected && props.selected.length > 0) ? _c('v-layout', {
          staticClass: "mx-2 mb-2"
        }, [_c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('icd-input', {
          attrs: {
            "persistent-hint": "",
            "label": "Apply ICD-10 code to selected rows",
            "hint": "Type an ICD-10 code, or click the search icon to search (ctrl s). "
          },
          model: {
            value: (_vm.icdCode),
            callback: function($$v) {
              _vm.icdCode = $$v
            },
            expression: "icdCode"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-btn', {
          staticClass: "mt-4",
          attrs: {
            "small": "",
            "outline": "",
            "disabled": !_vm.icdCode,
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.setcodes(props.selected)
            }
          }
        }, [_vm._v("Set ICD\n              "), _c('span', {
          staticClass: "hidden-xs-only ml-1"
        }, [_vm._v(" for selected line items")])])], 1)], 1) : _vm._e()]
      }
    }, {
      key: "order",
      fn: function(props) {
        return [_c('v-text-field', {
          staticClass: "caption",
          attrs: {
            "hide-details": "",
            "type": "number"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.noop.apply(null, arguments)
            },
            "input": function($event) {
              return _vm.updateOrder(props.item, props.value)
            }
          },
          model: {
            value: (props.value),
            callback: function($$v) {
              _vm.$set(props, "value", $$v)
            },
            expression: "props.value"
          }
        })]
      }
    }, {
      key: "field-icd10",
      fn: function(props) {
        return [_c('v-dialog', {
          attrs: {
            "fullscreen": ""
          },
          model: {
            value: (_vm.ICD10codepicker),
            callback: function($$v) {
              _vm.ICD10codepicker = $$v
            },
            expression: "ICD10codepicker"
          }
        }, [_c('v-system-bar', {
          staticClass: "visible-ios-only main",
          attrs: {
            "color": _vm.themeColor
          }
        }), _vm._v(" "), _c('v-toolbar', {
          attrs: {
            "dark": "",
            "dense": "",
            "short": "",
            "color": _vm.themeColor
          }
        }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.ICD10codepicker = false
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('icd-picker', {
          attrs: {
            "touch": _vm.icdtouch,
            "initial-search-string": _vm.codeSearchString
          },
          on: {
            "input": function($event) {
              return _vm.setIcdCode(props)
            }
          },
          model: {
            value: (_vm.code),
            callback: function($$v) {
              _vm.code = $$v
            },
            expression: "code"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "append-icon": "search",
            "label": "ICD10 code",
            "hint": "Please provide an ICD10 diagnosis code",
            "required": "",
            "rules": [function (v) { return !!v || 'IDC10 code is required'; }]
          },
          on: {
            "click:append": function($event) {
              return _vm.showICDPicker(props)
            },
            "input": function($event) {
              _vm.typedIcd10Code = props.selectedRow[props.header.value]
            }
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_vm._l((_vm.suggestedICD10), function(code, index) {
          return [(code) ? _c('v-chip', {
            key: (code + "-" + index),
            attrs: {
              "small": "",
              "label": ""
            },
            on: {
              "click": function($event) {
                props.selectedRow.icd10 = code
              }
            }
          }, [_vm._v("\n            " + _vm._s(code) + "\n          ")]) : _vm._e()]
        })], 2)]
      }
    }, {
      key: "field-process",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "fullscreen": ""
          },
          model: {
            value: (_vm.processcodepicker),
            callback: function($$v) {
              _vm.processcodepicker = $$v
            },
            expression: "processcodepicker"
          }
        }, [_c('v-system-bar', {
          staticClass: "visible-ios-only main",
          attrs: {
            "color": _vm.themeColor
          }
        }), _vm._v(" "), _c('v-toolbar', {
          attrs: {
            "dark": "",
            "dense": "",
            "short": "",
            "color": _vm.themeColor
          }
        }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.processcodepicker = false
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('process-code-picker', {
          attrs: {
            "initial-search-string": _vm.processSearchString
          },
          on: {
            "input": function($event) {
              return _vm.setProcessCode(props)
            }
          },
          model: {
            value: (_vm.process),
            callback: function($$v) {
              _vm.process = $$v
            },
            expression: "process"
          }
        })], 1), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "append-icon": "search",
            "label": "Process code",
            "required": "",
            "rules": [function (v) { return !!v || 'Process code is required (just put a - if you really don\'t want to use it)'; }]
          },
          on: {
            "click:append": function($event) {
              return _vm.showProcessPicker(props)
            },
            "input": function($event) {
              _vm.typedProcessCode = props.selectedRow[props.header.value]
            }
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1)]
      }
    }, {
      key: "field-nappi",
      fn: function(props) {
        return _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          staticClass: "text-xs-right",
          attrs: {
            "xs12": ""
          }
        }, [(_vm.moreCodes === false) ? _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.moreCodes = true
            }
          }
        }, [_vm._v("More code options")]) : _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.moreCodes = false
            }
          }
        }, [_vm._v("Fewer options")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [(_vm.moreCodes) ? _c('v-text-field', {
          attrs: {
            "label": "NAPPI code"
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        }) : _vm._e()], 1)], 1)
      }
    }, {
      key: "field-price",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "prefix": _vm.defaultCurrency,
            "label": "Price",
            "type": "number",
            "required": "",
            "rules": [function (v) { return !!v || 'Price is required'; }]
          },
          model: {
            value: (props.selectedRow[props.header.value]),
            callback: function($$v) {
              _vm.$set(props.selectedRow, props.header.value, $$v)
            },
            expression: "props.selectedRow[props.header.value]"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, _vm._l((_vm.suggestedPrices), function(code, index) {
          return _c('v-chip', {
            key: index,
            attrs: {
              "small": "",
              "label": ""
            },
            on: {
              "click": function($event) {
                props.selectedRow.price = code.price;
                props.selectedRow.process = code.name
              }
            }
          }, [_c('strong', [_vm._v(_vm._s(code.name))]), _vm._v(" \n            " + _vm._s(_vm.formatCurrency(code.currency, (parseFloat(code.price)))) + "\n          ")])
        }), 1)]
      }
    }], null, false, 1766410603)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "dialog-header"
    },
    slot: "dialog-header"
  }, [_c('v-snackbar', {
    staticClass: "ma-0",
    attrs: {
      "absolute": "",
      "top": "",
      "color": _vm.snack.type
    },
    model: {
      value: (_vm.snack.visible),
      callback: function($$v) {
        _vm.$set(_vm.snack, "visible", $$v)
      },
      expression: "snack.visible"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.snack.message) + "\n          "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snack.visible = false
      }
    }
  }, [_vm._v("\n            Close\n          ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.withTotal) ? _c('v-card-actions', {
    staticClass: "grey lighten-2"
  }, [_c('v-chip', {
    staticClass: "pa-0",
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.appointmentId))]), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.table.data && _vm.table.data.length > 0) ? _c('h3', {
    staticClass: "subheading mr-4"
  }, [_vm._v("\n        Total:\n        " + _vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.totalPrice)) + "\n      ")]) : _vm._e()], 1) : _vm._e()], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!this.appointmentRequest.loading) ? _c('v-card-text', [(_vm.appointmentId && _vm.appointmentId > 0) ? _c('div', [_c('v-icon', [_vm._v("warning")]), _vm._v(" unable to load codes.\n      "), _c('v-btn', {
    attrs: {
      "loading": _vm.appointmentRequest.loading,
      "flat": ""
    },
    on: {
      "click": _vm.loadAppointments
    }
  }, [_vm._v("Try again ")])], 1) : _c('v-alert', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n      Something has gone wrong.\n      Try choosing another appointment and then\n      coming back to this one?\n    ")])], 1) : _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "size": "32",
      "width": "2"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f75ea814","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/AppointmentCodes.vue
// module id = 1548
// module chunks = 9